import React, { Component } from "react";
import { ReactComponent as ShareButtonIcon } from "../Images/Share_button.svg";

class ShareButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showShareLink: false,
      shareLink: "",
    };
  }

  showShareLink = (shareLink) => {
    shareLink = window.location.origin + shareLink;
    this.setState({ showShareLink: !this.state.showShareLink, shareLink });
  };

  render() {
    return (
      <div className="shareLink--wrapper">
        <a
          className="shareLink--button"
          onClick={() => {
            this.showShareLink(this.props.shareLink);
          }}
        >
          <ShareButtonIcon></ShareButtonIcon>
        </a>
        {this.state.showShareLink && (
          <p class="shareLink--link">
            Share this project with this link:<br></br>
            {this.state.shareLink}
          </p>
        )}
      </div>
    );
  }
}

export default ShareButton;
